
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".related-product-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".pdp-main-wrapper").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".custom-pdp-two-col-section").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
    productDataUpdate(card, false);
  });
  // document.querySelectorAll(".product-new-default-section").forEach(function (card) {
  //   productDataUpdate(card, true);
  // });
});
/*
// Select your target UL
const targetUl = document.querySelector('ul.product-grid'); // change selector to your specific UL

if (targetUl) {
  const observer = new MutationObserver(mutationsList => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {

        // Handle added LIs
        [...mutation.addedNodes].forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'LI') {
            onListChange('added', node);
          }
        });

        // Handle removed LIs
        [...mutation.removedNodes].forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'LI') {
            onListChange('removed', node);
          }
        });

      }
    }
  });

  observer.observe(targetUl, { childList: true, subtree: false });

  // Your custom handler
  function onListChange(action, liElement) {
    // 💡 Put your custom logic here
    document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  }
} else {
  console.warn('Target UL not found!');
}*/


function productDataUpdate(card, isPDP){

  let buttons = card.querySelectorAll(".product-selector-color");
  if (buttons.length === 0) {
    buttons = card.querySelectorAll(".product-selector-options");
  }
  const imageEl = card.querySelector("[data-product-image]");
  const priceEl = card.querySelector("[data-actual-price]");
  const comparePriceEl = card.querySelector("[data-compare-price]");
  const pdpImageEls = card.querySelectorAll(".pdp-image-video-wrap");
  const buyButtonEl = card.querySelector("[data-buyButton]");
  const cardAnchorEls = card.querySelectorAll("a[data-product-url]");
  const productInfoTextEl = card.querySelector(".product-details .product-info-text[data-product-info]");
  const priceWrap = card.querySelector(".product-price[data-variant-id]");

  // const addToCartText = card.querySelector("[data-buyButton] span").getAttribute("data-addToCartText");
  // const soldOutText = card.querySelector("[data-buyButton] span").getAttribute("data-soldOutText");
  const addToCartText = card.getAttribute("data-addToCartText");
  const soldOutText = card.getAttribute("data-soldOutText");
  
  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Remove active class
            console.log('swatch clicked');
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
  
      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const img = btn.getAttribute("data-image");
      const price = btn.getAttribute("data-price");
      const compareAtPrice = btn.getAttribute("data-compare-at-price");
      const availability = btn.getAttribute("data-availability");
      const variantURL = btn.getAttribute("data-url");
      const product_color = btn.getAttribute("data-color");
    
      // Update image
      if(isPDP){
        if(pdpImageEls){
          const btnDataLink = btn.getAttribute("data-link");
          pdpImageEls.forEach(el => {
            if (el.getAttribute("data-id") === btnDataLink) {
              el.classList.add("active");
            } else {
              el.classList.remove("active");
            }
          });
        }

        const colorText = document.querySelector(".color-text");
    
        if (colorText) {
            colorText.textContent = product_color;
        }
        if (product_color){
           const variantGalleryImages = document.querySelectorAll('.variant-color-image-'+product_color);
           if (variantGalleryImages.length > 0) {
              $('.variant-gallery-images').hide();
               variantGalleryImages.forEach(el => {
                el.style.display = 'block';
              });
           }
        }
                
        
        // Update for PDP Top sticky bar start
        const pdpTopBarEl = document.querySelector(".pdp-top-sticky-bar");
        
        if (pdpTopBarEl) {
          const pdpTopBuyButtonEl = pdpTopBarEl.querySelector("[data-buyButton]");
          const pdpTopBuyButtonTextEls = pdpTopBuyButtonEl?.querySelectorAll("[data-buyButtonText]");
          const actualPriceEl = pdpTopBarEl.querySelector("[data-actual-price]");
          const comparePriceEle = pdpTopBarEl.querySelector("[data-compare-price]");
        
          if (pdpTopBuyButtonEl && pdpTopBuyButtonTextEls) {
            if (availability === 'true' || availability === true) {
              pdpTopBuyButtonTextEls.forEach(el => {
                el.textContent = addToCartText || "Buy now";
              });
              pdpTopBuyButtonEl.removeAttribute("disabled");
            } else {
              pdpTopBuyButtonTextEls.forEach(el => {
                el.textContent = soldOutText || "Not available";
              });
              pdpTopBuyButtonEl.setAttribute("disabled", "");
            }
          }
        
          if (actualPriceEl) {
            actualPriceEl.textContent = price;
          }
        
          if (comparePriceEle) {
            if (compareAtPrice && compareAtPrice !== price) {
              comparePriceEle.style.display = 'inline-block';
              comparePriceEle.textContent = compareAtPrice;
            } else {
              comparePriceEle.style.display = 'none';
            }
          }
        }
        //end
        
        document.querySelectorAll('.form-variant-id-' + productId).forEach(el => {
          el.value = variantId;
        });

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variantId);

        // Update URL without page reload
        window.history.replaceState({}, '', newUrl);
        
      }else{
        //document.querySelector('.form-variant-id-'+productId).value = variantId;
        const input = document.querySelector('.form-variant-id-' + productId);
        if (input) {
          input.value = variantId;
        } else {
          console.warn('No element found with class: .form-variant-id-' + productId);
        }
        
        if (img && imageEl) {
          imageEl.src = img;
        }

        //Update variant url 
        cardAnchorEls.forEach(el => {
          el.href = variantURL;
        });

        if(priceWrap){
          priceWrap.setAttribute('data-variant-id', variantId)
        }
        
      }

      // Update addtocart button text
      if(buyButtonEl){
          const buttonTextEls = buyButtonEl.querySelectorAll("[data-buyButtonText]");
          
          if (availability === 'true' || availability === true) {
            buttonTextEls.forEach(el => {
              el.textContent = addToCartText || "Buy now";
            });
            buyButtonEl.removeAttribute("disabled");
            if(productInfoTextEl){
              productInfoTextEl.style.display = 'none';
            }
          } else {
            buttonTextEls.forEach(el => {
              el.textContent = soldOutText || "Not available";
            });
            buyButtonEl.setAttribute("disabled", "");
            if(productInfoTextEl){
              productInfoTextEl.style.display = 'block';
            }
          }
      }
  
      // Update actual price
      if (priceEl) {
        priceEl.textContent = price;
      }
  
      // Update compare at price (or hide if not applicable)
      if (comparePriceEl) {
        if (compareAtPrice && compareAtPrice !== price) {
          comparePriceEl.style.display = 'inline-block';
          comparePriceEl.textContent = compareAtPrice;
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (pricelist != undefined) {
        display_price(variantId, isPDP);
      }

    });
  });
}  

/** Menu hover image start */
function handleMegaMenuImageSwap() {
  $(".mega-menu-links-col a").off("mouseenter click");

  if ($(window).width() > 1023) {
    //Main menu
    $(".main-nav-list a").on("mouseenter", function () {
      const newImage = $(this).data("image");
      const mainMenuId = $(this).data("id");
      
     if (newImage && mainMenuId) {
        $("#hover-image-" + mainMenuId).attr("src", newImage);
      }
    });

    //navigation menu sub
    $(".mega-menu-links-col a").on("mouseenter", function () {
      const newImage = $(this).data("image");
      const mainMenuId = $(this).data("id");
      if (newImage && mainMenuId) {
        $("#hover-image-" + mainMenuId).attr("src", newImage);
      }
    });
  } else {
    $(".main-nav-list a").on("click", function () {
      const newImage = $(this).data("image");
      if (newImage) {
        $("#mobile-hover-image").attr("src", newImage);
      }
    });
    $(".mega-menu-links-col a").on("click", function () {
      const newImage = $(this).data("image");
      if (newImage) {
        $("#mobile-hover-image").attr("src", newImage);
      }
    });
  }
}

$(document).ready(handleMegaMenuImageSwap);
// Run on window resize
$(window).on("resize", handleMegaMenuImageSwap);

/*** Menu hover image end **/

$(document).ready(function () {
  $(".shopping-btn").on("click", function () {
    const cartDrawerCloseBtn = $(".cart-drawer__close-button");
    if (cartDrawerCloseBtn.length) {
      setTimeout(() => {
        cartDrawerCloseBtn.trigger("click");
      }, 300);
    }
  });

   // Close cart drawer when clicking outside it (on body)
    //$(document).on("click", function (e) {
    $(".cart-drawer .cart-overlay").on("click", function (e) {
      const $cartDrawer = $(".cart-drawer");
      const $closeBtn = $(".cart-drawer__close-button");
  
      $closeBtn.trigger("click");
    });

  // Prevent body click from closing drawer when clicking inside it
  $(".cart-drawer").on("click", function (e) {
    e.stopPropagation();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-select').forEach(function (selectEl) {
    selectEl.addEventListener('change', function (event) {
      const quantity = event.target.value;
      const dataId = selectEl.dataset.id;

      const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

      if (!quantityWrapper) return;
      const inputEl = quantityWrapper.querySelector('.quantity_input'+dataId);
      if (!inputEl) return;
  
      inputEl.value = quantity;
      inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  });
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.quantity-select')) {
  
    const selectEl = event.target;
    const quantity = selectEl.value;
    const dataId = selectEl.dataset.id;

    const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

    const inputEl = quantityWrapper.querySelector('.quantity_input' + dataId);
    if (!inputEl) return;

    inputEl.value = quantity;
    inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
  }
});

$(document).ready(function () {
  const currentUrl = window.location.pathname;
  $(".inner-page-navbar ul li a").removeClass("active");
  $(".inner-page-navbar ul li a").each(function () {
    const linkHref = $(this).attr("href");
    // Skip empty href or just "#"
    if (!linkHref || linkHref === "#") return;

    // Add active only if URL matches exactly or contains the path
    if (currentUrl.indexOf(linkHref) !== -1 && linkHref !== "/") {
      $(this).addClass("active");
    }
  });
});

/** Start Blog page menu filters **/
document.addEventListener('DOMContentLoaded', function () {
  const currentUrl = window.location.href;
  const tabLinks = document.querySelectorAll('.blog-listing-filter ul li a');

  tabLinks.forEach(function (link) {
    const linkHref = link.getAttribute('href');
    if (currentUrl.includes(linkHref) && linkHref.includes('/tagged/')) {
      document.querySelectorAll('.blog-listing-filter ul li').forEach(el => el.classList.remove('current'));
      link.closest('li').classList.add('current');
    }
  });
});
/** End Blog page menu filters **/


document.addEventListener("DOMContentLoaded", function () {
  const tocList = document.querySelector('.top-content .sidebar');
  const article = document.querySelector('.article-template');

  if (!tocList || !article) return;

  const headings = article.querySelectorAll('h2.scroll-section, h3.scroll-section');

  function generateId(text) {
    // Only take first part before comma (if any)
    let baseText = text.split(',')[0];
    return baseText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')        // Remove punctuation
      .replace(/\s+/g, '-')            // Replace spaces with hyphens
      .replace(/-+/g, '-');            // Remove repeated dashes
  }

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let id = generateId(heading.textContent);
    // Ensure unique ID if duplicate exists
    let uniqueId = id;
    let suffix = 1;
    while (usedIds.has(uniqueId)) {
      uniqueId = `${id}-${suffix++}`;
    }
    usedIds.add(uniqueId);

    heading.setAttribute('id', uniqueId);
    const li = document.createElement('li');
    li.setAttribute('data-target', `#${uniqueId}`);
    if (index === 0) li.classList.add('active-slide');

    const button = document.createElement('button');
    button.textContent = heading.textContent;

    li.appendChild(button);
    tocList.appendChild(li);
  });

  // Scroll and set active class
  document.querySelectorAll('.toc-list li button').forEach(btn => {
    btn.addEventListener('click', function () {
      const targetId = this.parentElement.getAttribute('data-target');
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update active-slide
      document.querySelectorAll('.toc-list li').forEach(li => li.classList.remove('active-slide'));
      this.parentElement.classList.add('active-slide');
    });
  });
});


/*** Collection List Start ****/
function applyFilters() {

  const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
  const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
  const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());

  let visibleCount = 0;

  document.querySelectorAll('.product-list-card.collection_page').forEach(card => {
    const productTags = (card.dataset.tags || '')
      .split(',')
      .map(tag => tag.trim().toLowerCase());

    const productColor = (card.dataset.color || '')
      .split(',')
      .map(color => color.trim().toLowerCase());

    const title = card.dataset.title || 'No Title';

    const categoryTagMatch = selectedCategories.length === 0 ||
      selectedCategories.some(cat => productTags.includes(`category-${cat}`));

    const colorMatch = selectedColors.length === 0 ||
      selectedColors.some(color => productColor.includes(color));

    const featuresTagMatch = selectedFeatures.length === 0 ||
      selectedFeatures.some(feature => productTags.includes(`feature-${feature}`));


    const isVisible = categoryTagMatch && colorMatch && featuresTagMatch;

    if (isVisible) {
      card.style.display = 'block';
      visibleCount++;  
    } else {
      card.style.display = 'none';
    }
  });

  const countElement = document.getElementById('filter-result-count');
  if (countElement) {
    countElement.textContent = `${visibleCount} Product${visibleCount !== 1 ? 's' : ''}`;
  }

}
const applyFiltersButton = document.getElementById("apply-filters");
if (applyFiltersButton) {
  applyFiltersButton.addEventListener("click", applyFilters);
}



/*document.getElementById('custom-filters').addEventListener('submit', function (e) {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const params = new URLSearchParams();
  for (const [key, value] of formData.entries()) {
    params.append(key, value);
  }

  const collectionUrl = window.location.pathname;
  const filterUrl = `${collectionUrl}?${params.toString()}`;
  filterCollectionList(filterUrl);
  
});*/

document.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
  radio.addEventListener('change', function () {
    const selectedValue = this.value;

    const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}?sort_by=${selectedValue}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = this.dataset.sortby;
  });
});

function contentanimationForAjax() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("content-animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".content-visible").each(function () {
    observer.observe(this);
  });
}


function filterCollectionList(filterUrl){
  fetch(filterUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelector('#filtered-products');
      document.getElementById('filtered-products').innerHTML = newProducts.innerHTML;

      //applyFilters();
       const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
      const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
      const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());
      

      const count = document.querySelectorAll('#filtered-products li').length;
      document.querySelector('#filter-result-count').textContent = count+' Products';

      applyFilters();

      contentanimationForAjax();
      // Re-initialize
      document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
        productDataUpdate(card, false);
      });
    });
}


function updateFilterCounts() {
  const checkboxes = document.querySelectorAll('.filter-checkbox-input');
  const counts = {};
  let anyChecked = false;

  checkboxes.forEach(cb => {
    if (cb.checked) {
      anyChecked = true;
      const type = cb.dataset.filtertype;
      counts[type] = (counts[type] || 0) + 1;
    }
  });

  const filterTypes = ['color', 'category', 'feature'];
  filterTypes.forEach(type => {
    // Support both desktop and mobile badges
    const badgeTypes = document.querySelectorAll(`.${type}-filter-badge`);
    badgeTypes.forEach(badgeType => {
      badgeType.style.display = counts[type] ? 'inline-flex' : 'none';
    });

    const badges = document.querySelectorAll(`#${type}-filter-badge-count`);
    badges.forEach(badge => {
      badge.textContent = counts[type] || 0;
    });
  });

  const sortTab = document.querySelector('.sort-by-tab');
  if (sortTab) {
    sortTab.classList.toggle("disabled", anyChecked);
  }
}
document.addEventListener('change', function (event) {
  if (event.target.classList.contains('filter-checkbox-input')) {
    updateFilterCounts();
  }
});

document.getElementById("clear-filter")?.addEventListener("click", () => {
	const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = '';
});

document.getElementById("clear-all-filters")?.addEventListener("click", () => {
  // Uncheck all checkboxes in all filter groups
  document.querySelectorAll('.filter-color, .filter-category, .filter-feature')
    .forEach(input => input.checked = false);
  document.querySelectorAll('.filter-badge').forEach(badge => {
    badge.style.display = 'none';
  });
  document.querySelectorAll('.filter-badge-count').forEach(el => {
    el.textContent = '';
  });

  // Re-apply filter logic
  applyFilters();
});

document.querySelectorAll('.close-icon-btn').forEach(button => {
  button.addEventListener('click', () => {
    const filterType = button.dataset.filterType;

    // Uncheck all checkboxes of that filter group
    document.querySelectorAll(`.filter-${filterType}`).forEach(input => {
      input.checked = false;
    });

    // Hide the badge and clear count
    const badge = button.closest('.filter-badge');
    if (badge) {
      badge.style.display = 'none';
      const countSpan = badge.querySelector('span');
      if (countSpan) countSpan.textContent = '';
    }

    // Re-apply filtering
    applyFilters();
  });
});

/*** Collection List End ****/

/** sennheiser-consumer-ambassador-program iframe src start **/
$('.showIframeBtn').on('click', function () {
    $('.consumer-ambassador-iframe').toggleClass('active');
    $('body').toggleClass('consumer-ambassador-iframe-open');
});
/** sennheiser-consumer-ambassador-program iframe src end **/

// Show more button JS for collection page
document.addEventListener('click', function(e) {
  if (e.target.matches('.custom-collection-product-grid button.more-product[data-product-count-limit]')) {
    const hiddenItems = document.querySelectorAll('.custom-collection-product-grid .product-grid-list .product-list-card.hidden');
    hiddenItems.forEach(item => {
      item.classList.remove('hidden');
    });
    e.target.style.display = 'none';
  }
});
//End

function closeSortingDetailsMobile() {
  const detailsElements = document.querySelectorAll('.no-filter-yes-sorting .sorting-filter details[open]');
  detailsElements.forEach(el => el.removeAttribute('open'));
}

window.addEventListener('DOMContentLoaded', closeSortingDetailsMobile);
window.addEventListener('resize', closeSortingDetailsMobile);

//ACF custom pricing JS

var pricelist = getCookie("pricelist");
(() => {
  let external_price;
  let external_token;

  /** --------------------------
  * Build custom line item properties
  * -------------------------- */
  const buildCustomProperties = (external_price, external_token, pricelist) => {
    const properties = {};
    if (external_price) properties._external_price = String(external_price);
    if (external_token) properties._external_token = String(external_token);
    if (pricelist && external_price) properties._external_pricelist = pricelist;
    return properties;
  };

  /** --------------------------
  * Update cart count in header
  * -------------------------- */
  const updateCartCount = async (onReload) => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const countElem = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
      if (countElem){
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        countElem.textContent = cart.item_count;
        
      }else{
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        document.querySelector('.header-actions__cart-icon .cart-bubble__text').innerHTML = '<span class="visually-hidden">Total items in cart:' +cart.item_count+'</span><span class="cart-bubble__text-count" aria-hidden="true">'+cart.item_count+'</span>';
      } 
      if(!onReload){
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.toggle('cart-bubble--animating');
        setTimeout(function(){
          document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('cart-bubble--animating');
        }, 300)
      }

    } catch (err) {
      console.error('❌ Error updating cart count:', err);
    }
  };

  updateCartCount(true);

  /** --------------------------
  * Bind add-to-cart events
  * -------------------------- */
  const buttons = document.querySelectorAll("product-form-component add-to-cart-component button[data-addToCartCustom]");
  if (!buttons.length) {
    console.warn('⚠️ No add-to-cart buttons found on page.');
    return;
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', async (e) => {
      if (button.classList.contains("klaviyo-bis-trigger")) {
        console.log("⏭️ Skipped: Klaviyo BIS trigger active");
        return;
      }
      e.preventDefault();

      const form = button.closest('product-form-component');
      if (!form) {
        console.error('❌ product-form-component not found for this button');
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) {
        console.error('❌ Variant ID not found inside form');
        return;
      }

      const variant = parseInt(variantInput.value);

      if (typeof pricelist !== 'undefined' && benefits[variant] && benefits[variant][pricelist]) {
        external_price = benefits[variant][pricelist].closed_shop_price;
        external_token = benefits[variant][pricelist].closed_shop_token;
      }

      const properties = buildCustomProperties(external_price, external_token, pricelist);

      const data = {
        id: variant,
        quantity: 1,
        properties
      };

      console.log(data)
      // Perform AJAX add-to-cart
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`HTTP ${response.status}: ${text}`);
        }

        updateCartCount();

        const responseJson = await response.json()
        document.dispatchEvent(new CustomEvent('AddToCart', {
          detail: {
            productName: responseJson.product_title
          }
        }));

      } catch (error) {
        console.error('❌ Error adding to cart:', error);
      }
    });
  });
})();


if (pricelist != undefined) {
  var c_variant_id;
  if(document.querySelector('.pdp-main-wrapper')){
    c_variant_id = parseFloat(document.querySelector('.pdp-main-wrapper product-form-component form.shopify-product-form input[name=id]').value);
  }else if(document.querySelector('.custom-pdp-two-col-section')){
    c_variant_id = parseFloat(document.querySelector('.custom-pdp-two-col-section product-form-component form.shopify-product-form input[name=id]').value);
  }
  
  for (var prop in benefits) {
    var closed_shop = benefits[prop][pricelist];

    if (closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);
      
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.innerText = compare_at_price_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-actual-price]').forEach(el => {
        el.innerText = money_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.style.removeProperty('display');
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"]').forEach(el => {
        const next = el.nextElementSibling;
        if (!next || !next.classList.contains('promotional-price')) {
          el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
        }
      });
      
      if(prop == c_variant_id){
        document.querySelectorAll(".closed_shop_price").forEach(el => {
          el.value = closed_shop.closed_shop_price;
          el.disabled = false;
        });
        document.querySelectorAll(".closed_shop_token").forEach(el => {
          el.value = closed_shop.closed_shop_token;
          el.disabled = false;
        });

        document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
          el.value = pricelist;
          el.disabled = false;
        });
        
      }

    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
  

var display_price = function(current_variant_id, isPDP) {
  var variant_id = getUrlParameter("variant");
  if (variant_id == undefined) {
    variant_id = current_variant_id;
  }
  var variant = benefits[variant_id];
  if (variant != null && variant != undefined) {
    var pricelist = getCookie("pricelist");
    var closed_shop = variant[pricelist];
    if (closed_shop != null && closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);

      if(isPDP){
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-actual-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-actual-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id], .pdp-top-sticky-bar .product-price[data-variant-id], .custom-pdp-two-col-section .product-price[data-variant-id]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });

          document.querySelectorAll(".closed_shop_price").forEach(el => {
            el.value = closed_shop.closed_shop_price;
            el.disabled = false;
          });
          document.querySelectorAll(".closed_shop_token").forEach(el => {
            el.value = closed_shop.closed_shop_token;
            el.disabled = false;
          });
          document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
            el.value = pricelist;
            el.disabled = false;
          });
      }else{
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next || !next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });
      }

      
    }
  }
}
// END 

/****Counry lanage selector start ********/
  const countryLanguageMap = {
  "Albania": [
  	{ label: "English", value: "en" }
  ],
  "Australia": [
  	{ label: "English", value: "en" }
  ],
  "Austria": [
  	{ label: "German", value: "de" }, 
  	{ label: "English", value: "en" }
  ],
  "Belgium": [
  	{ label: "Dutch", value: "nl" },
  	{ label: "Français", value: "fr" }, 
  	{ label: "German", value: "de" }
  ],
  "Bosnia and Herzegovina": [
  	{ label: "English", value: "en" }
  ],
  "Brazil": [
  	{ label: "Portuguese", value: "pt" }
  ],
  "Bulgaria": [
  	{ label: "English", value: "en" },
  ],
  "Canada": [
  	{ label: "Français", value: "fr-ca" },
  	{ label: "English", value: "en" }
  ],
  "Chinese Mainland": [
  	{ label: "English", value: "en" },
  	{ label: "Chinese", value: "zh" }
  ],
  "Croatia": [
  	{ label: "English", value: "en" }
  ],
  "Cyprus": [
  	{ label: "English", value: "en" },
  ],
  "Czech Republic": [
  	{ label: "English", value: "en" }
  ],
  "Denmark": [
  	{ label: "Danish", value: "da" }
  ],
  "Estonia": [
  	{ label: "English", value: "en" }
  ],
  "Finland": [
  	{ label: "English", value: "en" }
  ],
  "France": [
  	{ label: "Français", value: "fr" }
  ],
  "Georgia": [
  	{ label: "English", value: "en" }
  ],
  "Germany": [
  	{ label: "German", value: "de" },
  	{ label: "English", value: "en" }
  ],
  "Global": [
  	{ label: "English", value: "en" }
  ],
  "Hong Kong SAR": [
  	{ label: "Chinese", value: "zh" },
  	{ label: "English", value: "en" }
  ],
  "Hungary": [
  	{ label: "Hungarian", value: "hu" }
  ],
  "India": [
  	{ label: "English", value: "en" }
  ],
  "Indonesia": [
  	{ label: "English", value: "en" }
  ],
  "Ireland": [
  	{ label: "English", value: "en" }
  ],
  "Italy": [
  	{ label: "Italian", value: "it" }
  ],
  "Japan": [
  	{ label: "Japanese", value: "ja" },
  	{ label: "English", value: "en" }
  ],
  "Jersey": [
  	{ label: "English", value: "en" }
  ],
  "Kazakhstan": [
 	{ label: "English", value: "en" }
  ],
  "Korea, Republic of": [
	{ label: "Korean", value: "ko" }
  ],
  "Kuwait": [
  	{ label: "English", value: "en" }
  ],
  "Latvia": [
  	{ label: "English", value: "en" }
  ],
  "Lithuania": [
  	{ label: "English", value: "en" }
  ],
  "Luxembourg": [
  	{ label: "Français", value: "fr" },
  	{ label: "English", value: "en" }
  ],
  "Malaysia": [
  	{ label: "English", value: "en" }
  ],
  "Malta": [
  	{ label: "English", value: "en" }
  ],
  "Mexico": [
  	{ label: "Spanish", value: "es" }
  ],
  "Monaco": [
  	{ label: "English", value: "en" }
  ],
  "Netherlands": [
  	{ label: "Dutch", value: "nl" },
  	{ label: "English", value: "en" }
  ],
  "New Zealand": [
  	{ label: "English", value: "en" }
  ],
  "Norway": [
  	{ label: "Norwegian", value: "no" }
  ],
  "Oman": [
  	{ label: "English", value: "en" }
  ],
  "Philippines": [
  	{ label: "English", value: "en" }
  ],
  "Portugal": [
  	{ label: "Portuguese", value: "pt" }
  ],
  "Puerto Rico": [
  	{ label: "English", value: "en" }
  ],
  "Qatar": [
  	{ label: "English", value: "en" }
  ],
  "Romania": [
  	{ label: "English", value: "en" }
  ],
  "Serbia": [
  	{ label: "English", value: "en" }
  ],
  "Singapore": [
  	{ label: "English", value: "en" }
  ],
  "Slovakia": [
  	{ label: "English", value: "en" }
  ],
  "Slovenia": [
  	{ label: "English", value: "en" }
  ],
  "Spain": [
  	{ label: "Spanish", value: "es" }
  ],
  "Sweden": [
  	{ label: "Swedish", value: "sv" }
  ],
  "Switzerland": [
  	{ label: "Français", value: "fr" },
  	{ label: "German", value: "de" },
    { label: "English", value: "en" }
  ],
  "Taiwan": [
    { label: "Traditional Chinese", value: "zh-tw" },
  	{ label: "English", value: "en" }
  ],
  "Thailand": [
    { label: "Thai", value: "th" },
  	{ label: "English", value: "en" }
  ],
  "United Arab Emirates": [
  	{ label: "English", value: "en" }
  ],
  "United Kingdom": [
  	{ label: "English", value: "en" }
  ],
  "United States": [
  	{ label: "English", value: "en" }
  ],
  "Vietnam": [
    { label: "Vietnamese", value: "vi" },
  	{ label: "English", value: "en" },
  ]
};

const targetURLSubDomains = ["ca", "ch", "jp", "my", "nz", "ph", "tw", "us", "vn", "th"]

  const countrySelect = document.getElementById('country-select'); //IN JP
  const languageSelect = document.getElementById('language-select'); // en
  const countryContinueBtn = document.getElementById('country-continue-btn');

  countrySelect.addEventListener('change', function () {
     const selectedCountry = this.options[this.selectedIndex].text; 
    const languages = countryLanguageMap[selectedCountry] || [];

    const selectedCountryOption = this.options[countrySelect.selectedIndex];
    const targetUrl = selectedCountryOption.dataset.target;
    const selectedCountryValue = selectedCountryOption.value;
    const shopurl = document.getElementById("shop_url").value;
    
    // Clear existing options
    languageSelect.innerHTML = '<option value="">Select a language</option>';

    // Populate new options
    languages.forEach(language => {
      const option = document.createElement('option');
      option.value = language.value;
      option.textContent = language.label;
      languageSelect.appendChild(option);
    });
  });

  countryContinueBtn.addEventListener('click', function () {
    const languageSelectDropdown = document.getElementById('language-select');
    const selectedCountryOption = countrySelect.options[countrySelect.selectedIndex];
    const targetUrl = selectedCountryOption.dataset.target;
    const selectedLanguageOption = languageSelectDropdown.options[languageSelectDropdown.selectedIndex];
    const selectedLanguageValue = selectedLanguageOption.value;
    const selectedCountryValue = selectedCountryOption.value;
    const shopurl = document.getElementById("shop_url").value;
    const baseDomain = 'sennheiser-hearing.com';
    
    const url = new URL(window.location.href);
    if (targetUrl === 'same') {
      window.location.href = shopurl + '/' + selectedLanguageValue + '-' + selectedCountryValue;
    } else if (targetURLSubDomains.includes(targetUrl)) {
      const currentUrl = new URL(window.location.href);
      const currentHostname = currentUrl.hostname;
      const currentSubdomain = currentHostname.split('.')[0];

      const cleanPath = currentUrl.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i, "/");

      const langPrefix = selectedLanguageValue !== "en" ? `/${selectedLanguageValue}` : "";

      let redirectUrl = "";

      if (currentSubdomain === targetUrl) {
        redirectUrl = `https://${currentHostname}${langPrefix}${cleanPath}${currentUrl.search}`;
      } else {
        redirectUrl = `https://${targetUrl}.${baseDomain}${langPrefix}`;
      }

      window.location.href = redirectUrl;
    } else {
      window.location.href = "https://global.sennheiser-hearing.com/?glcountry=" + selectedCountryValue;
    }
  });
/****Counry lanage selector end ********/



/**Show cookie sidebar by cooking setting btn click start **/
document.getElementById('cookie-settings').addEventListener('click', function (e) {
  e.preventDefault();
  if (window.OneTrust) {
    OneTrust.ToggleInfoDisplay();
  } else {
    console.warn('OneTrust not found.');
  }
});
/**Show cookie sidebar by cooking setting btn click end **/



// document.addEventListener('DOMContentLoaded', function () {
//     function handleLanguageSwitch() {
//       var pathLang = window.location.pathname.split('/')[1]; // 'ko', 'en', etc.
//       var defaultLang = 'ja';

//       // If the pathLang is a supported Weglot language, switch to it
//       if (Weglot.getAvailableLanguages().includes(pathLang)) {
//         if (Weglot.getCurrentLang() !== pathLang) {
//           Weglot.switchTo(pathLang);
//         }
//       } else {
//         // If no language in path, switch to default (English)
//         if (Weglot.getCurrentLang() !== defaultLang) {
//           Weglot.switchTo(defaultLang);
//         }
//       }
//     }

//     // Wait for Weglot to be ready
//     const checkWeglotReady = setInterval(function () {
//       if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang && Weglot.getAvailableLanguages()) {
//         clearInterval(checkWeglotReady);
//         if (Weglot.getAvailableLanguages().length !== 0) {
//             handleLanguageSwitch();
//         }

//       }
//     }, 500);
//   });

window.onload = function () {
    function handleLanguageSwitch() {
      var pathLang = window.location.pathname.split('/')[1]; // 'ko', 'en', etc.
      var defaultLang = 'ja';

      // If the pathLang is a supported Weglot language, switch to it
      if (Weglot.getAvailableLanguages().includes(pathLang)) {
        if (Weglot.getCurrentLang() !== pathLang) {
          Weglot.switchTo(pathLang);
        }
      } else {
        // If no language in path, switch to default (English)
        if (Weglot.getCurrentLang() !== defaultLang) {
          Weglot.switchTo(defaultLang);
        }
      }
    }

    // Wait for Weglot to be ready
    const checkWeglotReady = setInterval(function () {
      if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang && Weglot.getAvailableLanguages()) {
        clearInterval(checkWeglotReady);
        if (Weglot.getAvailableLanguages().length !== 0) {
            handleLanguageSwitch();
        }

      }
    }, 500);

  }
 document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("language-select");
    if (!select) return;

    // Check if the path starts with /en/
    setTimeout(function() {
      if (window.location.pathname.startsWith("/fr-ca")) {
        select.value = "fr-ca";
      } else {
        select.value = "en";
      }
    }, 500)
  });


  //Show More on Similar Products
  function showMoreProducts() {
    document.getElementById('more-products').style.display = 'flex';
    document.getElementById('show-more-button').style.display = 'none';
  }

/* canvas images */
function productrotation() {
  const canvases = document.querySelectorAll(".product360Canvas");
 
  canvases.forEach((canvas) => {
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
 
    const productNumber = canvas.dataset.product || "1";
    const frameCount = parseInt(canvas.dataset.framecount, 10) || 1;
 
    const images = [];
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
   
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      const fileimage = '//ca.sennheiser-hearing.com/cdn/shop/files/0_267.webp?v=10579';
      const fileimage2 =  "//ca.sennheiser-hearing.com/cdn/shop/files/";
      img.src = `${fileimage2}0_${i + 1}.webp`;
      //img.src = `canvas-images/product${productNumber}/0_${i + 1}.webp`;
      images.push(img);
    }
 
    images[0].onload = function () {
      ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    };
 
    function drawFrame(frameIndex) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(images[frameIndex], 0, 0, canvas.width, canvas.height);
    }
 
    canvas.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
    });
 
    canvas.addEventListener("mouseup", () => {
      isDragging = false;
    });
 
    canvas.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
 
      let delta = e.pageX - startX;
      const sensitivity = 1;
 
      if (Math.abs(delta) > 1) {
        const framesToMove = Math.floor(Math.abs(delta) * sensitivity);
 
        currentFrame =
          delta > 0
            ? (currentFrame - framesToMove + frameCount) % frameCount
            : (currentFrame + framesToMove) % frameCount;
 
        drawFrame(currentFrame);
        startX = e.pageX;
      }
    });
  });
}
window.addEventListener("DOMContentLoaded", productrotation);

/** Custom toast start **/
document.addEventListener('DOMContentLoaded', () => {
  const toast = document.getElementById('custom-toast');
  const icon = document.getElementById('custom-toast-icon');
  const title = document.getElementById('custom-toast-title');
  const closeBtn = toast?.querySelector('.custom-toast__close');

  if (!toast || !icon || !title) {
    console.error('[Toast] ERROR: Missing required DOM elements.');
    return;
  }

  const ANIM_DURATION = 350;
  const VISIBLE_DURATION = 3000;

  let autoHideTimer = null;
  let transitionTimer = null;
  let isVisible = false;
  let isHiding = false;
  let queued = null;

  function normalizePayload(detail) {
    if (!detail || typeof detail !== 'object') {
      console.warn('[Toast] Invalid detail object. Using defaults.');
      return {
        titleText: 'Product',
        iconUrl: null
      };
    }

    return {
      titleText: typeof detail.titleText === 'string'
        ? detail.titleText
        : (detail.titleText + '' || 'Product'),
      iconUrl: typeof detail.iconUrl === 'string'
        ? detail.iconUrl
        : null
    };
  }

  function performShow(detail) {
    clearTimeout(autoHideTimer);
    clearTimeout(transitionTimer);

    title.textContent = detail.titleText;

    try {
      if (detail.iconUrl) icon.src = detail.iconUrl;
    } catch (e) {
      console.warn('[Toast] Invalid icon URL:', detail.iconUrl);
    }

    toast.classList.remove('hidden');

    void toast.offsetWidth;

    toast.classList.add('show');
    isVisible = true;
    isHiding = false;
    queued = null;

    autoHideTimer = setTimeout(() => startHide(), VISIBLE_DURATION);
  }

  function startHide() {
    if (!isVisible || isHiding) return;

    isHiding = true;
    toast.classList.remove('show');

    transitionTimer = setTimeout(() => {
      isVisible = false;
      isHiding = false;
      toast.classList.add('hidden');

      if (queued) {
        setTimeout(() => performShow(queued), 10);
      }
    }, ANIM_DURATION);
  }

  function showCustomToast(detail) {
    const payload = normalizePayload(detail);

    if (!isVisible && !isHiding) {
      performShow(payload);
      return;
    }

    if (isVisible && !isHiding) {
      queued = payload;

      if (autoHideTimer) {
        clearTimeout(autoHideTimer);
        autoHideTimer = null;
      }

      startHide();
      return;
    }

    if (isHiding) {
      queued = payload;
      return;
    }
  }

  function hideImmediate() {
    clearTimeout(autoHideTimer);
    clearTimeout(transitionTimer);

    autoHideTimer = null;
    transitionTimer = null;
    queued = null;

    isHiding = false;
    isVisible = false;

    toast.classList.remove('show');

    setTimeout(() => toast.classList.add('hidden'), 10);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      clearTimeout(autoHideTimer);
      autoHideTimer = null;
      queued = null;

      if (isVisible && !isHiding) startHide();
      else hideImmediate();
    });
  }

  document.addEventListener('ShowToast', (event) => {
    const detail = event?.detail;
    showCustomToast(detail);
  });
});
/** Custom toast end **/

/** Add to cart action start **/
document.addEventListener('DOMContentLoaded', () => {

  let cartAnimTimer = null;

  function cartCountAnimation() {
    const cartIcon = document.querySelector('.header-actions__action.action__cart');
    if (!cartIcon) return;

    if (cartAnimTimer) clearTimeout(cartAnimTimer);
    cartIcon.classList.remove('cart-added');

    void cartIcon.offsetWidth;

    cartIcon.classList.add('cart-added');

    cartAnimTimer = setTimeout(() => {
      cartIcon.classList.remove('cart-added');
    }, 3000);
  }

  function displayToast (event) {
    const productName = event?.detail?.productName;
    let messageSuffix = 'added to cart'
    if(window.Weglot && typeof Weglot.getCurrentLang === 'function') {
      const currentLang = Weglot.getCurrentLang();
      if(currentLang === "fr-ca") {
        messageSuffix = 'ajouté au panier'
      }
    }

    document.dispatchEvent(new CustomEvent('ShowToast', {
      detail: {
        titleText: `${productName} ${messageSuffix}`
      }
    }));
  }

  document.addEventListener('AddToCart', (event) => {
    displayToast(event)
    cartCountAnimation()
  });
})
/** Add to cart action end **/

/** Searchanise add to cart action start **/
document.addEventListener('DOMContentLoaded', () => {

  const updateCartCount = async (onReload) => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const countElem = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
      if (countElem){
        countElem.textContent = cart.item_count;
      }else{
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        document.querySelector('.header-actions__cart-icon .cart-bubble__text').innerHTML = '<span class="visually-hidden">Total items in cart:' +cart.item_count+'</span><span class="cart-bubble__text-count" aria-hidden="true">'+cart.item_count+'</span>';
      } 
      if(!onReload){
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.toggle('cart-bubble--animating');
        setTimeout(function(){
          document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('cart-bubble--animating');
        }, 300)
      }

    } catch (err) {
      console.error('❌ Error updating cart count:', err);
    }
  };

  $(document).on('Searchanise.AddToCartSuccess', async function (event, add_to_cart_id, product) {
    await updateCartCount();
    document.dispatchEvent(new CustomEvent('AddToCart', {
      detail: {
        productName: product.title
      }
    }));
  });
});
/** Searchanise add to cart action end **/
